// src/components/NavBar.tsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import LogoMain from "../../images/main-logo.png";
import Highlight from "../../images/nav-selected.png"; // Ton image splash rose

type NavItem = { label: string; href: string };

const NAV_ITEMS: NavItem[] = [
  { label: "Accueil", href: "/" },
  { label: "Qui-sommes-nous ?", href: "/qui-sommes-nous" },
  { label: "Devenir partenaire", href: "/devenir-partenaire" },
  { label: "Contact", href: "/contact" },
];

export default function NavBar() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) setOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur">
      <div className="relative">
        <div className="pointer-events-none absolute -top-5 left-0 right-0 h-5 bg-neutral-900 rounded-t-3xl md:rounded-t-[28px]" />
      </div>

      <nav
        aria-label="Navigation principale"
        className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 py-4 pt-8"
      >
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img src={LogoMain} alt="PACTE Claix" className="h-8 w-auto sm:h-9" />
            <span className="sr-only">PACTE Claix</span>
          </Link>

          {/* Menu desktop */}
          <ul className="hidden md:flex items-center gap-8">
            {NAV_ITEMS.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <li key={item.href} className="relative">
                  {isActive && (
                    <img
                      src={Highlight}
                      alt=""
                      className="absolute inset-0 w-full h-full object-contain -z-10"
                    />
                  )}
                  <Link
                    to={item.href}
                    className={`text-[15px] font-asap transition-opacity ${
                      isActive ? "font-semibold" : "text-black hover:opacity-80"
                    }`}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>

          {/* Burger mobile */}
          <button
            aria-label="Ouvrir le menu"
            className="md:hidden inline-flex items-center justify-center rounded-xl border border-neutral-300 p-2"
            onClick={() => setOpen((v) => !v)}
          >
            <svg
              className="h-5 w-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              {open ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Menu mobile déroulant */}
        {open && (
          <div className="md:hidden mt-3 overflow-hidden rounded-2xl border border-neutral-200 shadow-lg">
            <ul className="bg-white">
              {NAV_ITEMS.map((item) => (
                <li key={item.href} className="border-b last:border-b-0 border-neutral-200">
                  <Link
                    to={item.href}
                    className={`block px-4 py-3 text-[15px] font-asap ${
                      location.pathname === item.href ? "bg-pink-100 font-semibold" : "text-black"
                    }`}
                    onClick={() => setOpen(false)}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
}